import React, { memo } from 'react';
import { 
  EdgeProps, 
  getBezierPath, 
  EdgeLabelRenderer,
  BaseEdge 
} from 'reactflow';
import { IconButton, Tooltip } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { getCurvatureForCableFo, getFusionEdgePath } from '../../../utils/flowEdgeUtils';
import { useDiagramInteractive } from '../../../utils/useDiagramInteractive';

interface DeletableEdgeData {
  onDelete?: (edgeId: string) => void;
}

const DeletableEdge: React.FC<EdgeProps<DeletableEdgeData>> = ({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  sourceHandleId,
  targetHandleId,
  style = {},
  data,
  selected
}) => {
  const isDiagramInteractive = useDiagramInteractive();
  const isFusionSameNode = source === target;
  const [edgePath, labelX, labelY] = isFusionSameNode
    ? getFusionEdgePath(sourceX, sourceY, targetX, targetY, sourceHandleId, targetHandleId)
    : (() => {
        const curvature = getCurvatureForCableFo(sourceHandleId, targetHandleId, { sourceNodeId: source, targetNodeId: target });
        return getBezierPath({
          sourceX,
          sourceY,
          sourcePosition,
          targetX,
          targetY,
          targetPosition,
          ...(curvature != null && { curvature }),
        });
      })();

  const onEdgeClick = (evt: React.MouseEvent, edgeId: string) => {
    evt.stopPropagation();
    console.log(`🗑️ Deletando conexão ${edgeId}`);
    data?.onDelete?.(edgeId);
  };

  return (
    <>
      <BaseEdge 
        path={edgePath} 
        style={{
          ...style,
          strokeWidth: selected ? 3 : 2,
          stroke: selected ? '#f44336' : style.stroke || '#2196f3'
        }} 
      />
      
      {isDiagramInteractive && (
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            pointerEvents: 'all',
          }}
          className="nodrag nopan"
        >
          <Tooltip title="Deletar Conexão" arrow>
            <IconButton
              onClick={(event) => onEdgeClick(event, id)}
              size="small"
              sx={{
                backgroundColor: '#f44336',
                color: 'white',
                width: 20,
                height: 20,
                opacity: selected ? 1 : 0.7,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: '#d32f2f',
                  transform: 'scale(1.1)',
                  opacity: 1
                },
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
              }}
            >
              <DeleteIcon sx={{ fontSize: 12 }} />
            </IconButton>
          </Tooltip>
        </div>
      </EdgeLabelRenderer>
      )}
    </>
  );
};

export default memo(DeletableEdge); 